(function(){

   /********REMOVING UNWANTED ELEMENTS ON DIFFERENT SCREEN********/
  if(window.innerWidth >= 750){
    document.querySelectorAll(".desktop-hide")?.forEach(function(e){e.remove()});
  }else{
    document.querySelectorAll(".mobile-hide")?.forEach(function(e){e.remove()});
  }
  
  // Initialize Swiper function
  function initializeSwiper() {
    return new Swiper(".logo--bar--slider",{
      spaceBetween: 70,
      centeredSlides: true,
      speed: 5000,
      autoplay: {
        delay: 1,
      },
      loop: true,
      loopedSlides: 4,
      slidesPerView:'auto',
      allowTouchMove: false,
      disableOnInteraction: true
    });
  }
  
  // Store Swiper instance
  let swiperInstance = initializeSwiper();
  
  // Function to handle window resize
  function handleResize() {
    const windowWidth = window.innerWidth;
  
    if (windowWidth < 750) {
      if (!swiperInstance) {
        swiperInstance = initializeSwiper();
      }
    } else {
      if (swiperInstance.initialized) {
        swiperInstance.destroy(true, true);
        swiperInstance = null;
      }
    }
  }
  
  // Initial call to handleResize
  handleResize();
  
  // Listen for window resize events
  window.addEventListener('resize', handleResize);

})();